import { render, staticRenderFns } from "./TabsTemplate.vue?vue&type=template&id=003c9ef1&scoped=true"
import script from "./TabsTemplate.vue?vue&type=script&lang=js"
export * from "./TabsTemplate.vue?vue&type=script&lang=js"
import style0 from "./TabsTemplate.vue?vue&type=style&index=0&id=003c9ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c9ef1",
  null
  
)

export default component.exports